import React from 'react';
import { Link } from '@yme/components/Link';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { NavSectionSubtitleStyled, NavSectionTitleStyled, NavTitleStyled, SwitcherItemStyled, UpButtonStyled, } from './styled';
export const SwitcherItem = ({ switcherButton, hasItems, trackNavigation }) => {
    const SwitcherContent = (React.createElement(SwitcherItemStyled, { flexDirection: "column", isActive: switcherButton.isActive },
        React.createElement(NavSectionTitleStyled, { color: colorCoreWhite1000 }, switcherButton.title),
        switcherButton.subtitle && (React.createElement(NavSectionSubtitleStyled, { color: colorCoreWhite1000 }, switcherButton.subtitle))));
    if (switcherButton.isActive && !hasItems) {
        return React.createElement(NavTitleStyled, { isSwitcherItem: true }, SwitcherContent);
    }
    return (React.createElement(UpButtonStyled, { isSwitcherItem: true },
        React.createElement(Link, { to: switcherButton.link, onClick: trackNavigation(switcherButton.link, 'breadcrumb') }, SwitcherContent)));
};
